import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path
      fill="#D0D6CE"
      fillRule="evenodd"
      d="M4.58 16.145a3.5 3.5 0 0 1 6.534-1.362q.087-.005.177-.005a2.611 2.611 0 0 1 0 5.222H5.054a1.956 1.956 0 0 1-.473-3.855"
      clipRule="evenodd"
    />
    <path
      fill="#EDB326"
      d="M20.305 11.738c.376-.16.828.107.755.509a7.09 7.09 0 0 1-5.596 5.687q.036-.267.036-.545c0-2.082-1.552-3.768-3.534-4.065a5.08 5.08 0 0 0-3.91-1.824q-.528.001-1.03.104a7.089 7.089 0 0 1 5.794-7.596c.403-.073.67.38.51.755a5.315 5.315 0 0 0 6.975 6.975"
    />
  </>
);

const Weather33Colored = Icon('weather-33-colored', svgContents);

export default Weather33Colored;
